module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-bar-wrapper"
  }, [_c('el-menu', {
    attrs: {
      "mode": "horizontal",
      "theme": "dark",
      "default-active": _vm.activeId,
      "background-color": _vm.$mainThemeColor,
      "text-color": "#FFFFFF",
      "active-text-color": "#409EFF"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@static/icons/main-logo.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "platform-title"
  }, [_vm._v("视频管理系统")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-48230c7e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48230c7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/LinkBar.vue
// module id = 1283
// module chunks = 1